import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

function AppServices() {
  const { t } = useTranslation();

  const servicesData = [
    {
      id: 1,
      icon: 'fas fa-wrench',
      title: t('pipelineServices'),
      description: t('pipelineDesc')
    },
    {
      id: 2,
      icon: 'fas fa-plug',
      title: t('electricalServices'),
      description: t('electricalDesc')
    },
    {
      id: 3,
      icon: 'fas fa-hourglass',
      title: t('valveServices'),
      description: t('valveDesc')
    }
  ];

  return (
    <section id="services" className="services-block">
      <Container className="block container-box">
        <Container fluid>
          <div className="title-holder">
            <h2>{t('services')}</h2>
            <div className="subtitle">{t('servicesSubtitle', 'services we provide')}</div>
          </div>
          <Row>
            {
              servicesData.map(services => {
                return (
                  <Col sm={4} className='holder' key={services.id}>
                    <Container>
                      <Card className="shadow">
                        <div className="icon">
                          <i className={services.icon}></i>
                        </div>
                        <h3>{services.title}</h3>
                        <p>{services.description}</p>
                      </Card>
                    </Container>
                  </Col>
                );
              })
            }
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default AppServices;
